const ActionPosTypes = {
  OPEN_TURN: 'OPEN_TURN',
  CLOSE_TURN: 'CLOSE_TURN',
  CHANGE_MODAL_OPEN: 'CHANGE_MODAL_OPEN',
  CHANGE_MODAL_CLOSE: 'CHANGE_MODAL_CLOSE',
};

export default ActionPosTypes;
